<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <i class="form__icon icons icon-graduation"></i>
                    <vue-select label="name" :options="studyOptions" v-model="study.study" class="form__select" :class="{ 'has-value': study.study }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.study.study')}}</label>
                </div>
                <div class="form__item" v-if="study.study && study.study.id === 182">
                    <!-- <i class="form__icon icons icon-briefcase"></i> -->
                    <input v-model="study.study_name" class="form__input--text" type="text" :class="{ 'has-value': study.study_name }"/>
                    <label class="form__label">{{$t('forms.study.study_name')}}</label>
                </div>
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-direction"></i> -->
                    <vue-select label="name" :options="studyLevels" v-model="study.study_level" class="form__select" :class="{ 'has-value': study.study_level }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.study.study_level')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-location-pin"></i>
                    <input v-model="study.institute_name" class="form__input--text" type="text" required :class="{ 'has-value': study.institute_name }"/>
                    <label class="form__label">{{$t('forms.study.institute_name')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="study.start_date" class="form__input--text has-value" type="date"/>
                    <label class="form__label">{{$t('forms.study.start_date')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="study.end_date" class="form__input--text has-value" type="date"/>
                    <label class="form__label">{{$t('forms.study.end_date')}}</label>
                </div>
                <div class="form__item">
                    <label class="form__top_label">{{$t('forms.study.finished')}}</label>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectory_form__finished" v-model="study.finished" />
                        <label for="trajectory_form__finished" class="checkbox__label"> {{$t('common.yes')}}</label>
                    </div>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import Study from '@/models/Study';

    import { LOAD_STUDY_RESOURCES } from '@/store/modules/study-resources';

    @Component
    export default class StudyForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Study, default() {
            return new Study();
        } })
        study;

        created() {
            this.errors = [];
            this.$store.dispatch(LOAD_STUDY_RESOURCES, {});
        }

        get isSaveDisabled() {
            return !this.study.study || !this.study.study_level || !this.study.institute_name || !this.study.start_date || (this.study.finished && !this.study.end_date);
        }

        saveLoading = false;

        get studyOptions() {
            return this.$store.state.study_resources.study_options;
        }

        get studyLevels() {
            return this.$store.state.study_resources.study_levels;
        }

        get loading () {
            return this.saveLoading || this.$store.state.study_resources.loading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            // Submit boolean value also when false.
            this.study.finished = !!this.study.finished;
            // Always submit the study_name key:
            this.study.study_name = this.study.study_name ? this.study.study_name : '';

            this.study.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/StudyForm.vue